<template>
	<div>
		<button @click="showCart = true" class="btn fixed z-50 p-4 bottom-2 lg:bottom-4 right-1 lg:right-4 lg:left-auto bg-green-600 hover:bg-green-700 border-2 border-black text-white rounded-full">
			<!-- shopping cat icon-->
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="size-10">
				<path d="M2.25 2.25a.75.75 0 0 0 0 1.5h1.386c.17 0 .318.114.362.278l2.558 9.592a3.752 3.752 0 0 0-2.806 3.63c0 .414.336.75.75.75h15.75a.75.75 0 0 0 0-1.5H5.378A2.25 2.25 0 0 1 7.5 15h11.218a.75.75 0 0 0 .674-.421 60.358 60.358 0 0 0 2.96-7.228.75.75 0 0 0-.525-.965A60.864 60.864 0 0 0 5.68 4.509l-.232-.867A1.875 1.875 0 0 0 3.636 2.25H2.25ZM3.75 20.25a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM16.5 20.25a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z" />
			</svg>
		</button>

		<div v-if="showCart" class="fixed right-1 lg:right-4 left-1 lg:left-auto bottom-1 lg:bottom-4 bg-white px-4 py-4 z-50 border-2 border-b-4 border-gray-800 rounded-lg transition-all">
			<div id="cart-items" class="" v-show="step==0">
				<div class="flex justify-between items-center">
					<div class="font-bold text-xl">
						Your cart
					</div>
					<button @click="showCart = false" class="btn flex py-2 hover:border-gray-500 border-transparent border px-2 hover:bg-gray-100">
						Close
						<!-- close icon -->
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="size-6">
							<path fill-rule="evenodd" d="M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" />
						</svg>
					</button>
				</div>
				<div v-if="cart.items.length == 0" class="min-w-64 py-5 px-4 text-center bg-gray-100 rounded-md">
					Your cart is empty
				</div>
				<div v-for="item in cart.items" class="flex flex-col lg:flex-row px-2 py-2 border-b border-gray-200 lg:items-center">
					<img :src="productImage(item)" class="size-16 border border-gray-200 rounded-md">
					<div class="mt-2 lg:mt-0 lg:px-4">
						<p class="text-lg font-bold">{{ item.product.name }}</p>
						<p class="text-sm">{{ item.product.description }}</p>
						<button @click="removeItem(item)" class="btn px-0 py-1 hover:text-red-500 flex items-center gap-1">
							Remove
						</button>
					</div>
					<!-- quantity and color -->
					<div class="flex lg:justify-end items-center gap-2 mt-4 lg:ml-auto">
						<select class="hidden bg-gray-200 rounded-md p-1 px-2" :value="item.color">
							<option :value="color" v-for="color in ['gray', 'beige']">{{ color }}</option>
						</select>
						<div class="bg-gray-200 flex items-center p-0.5 rounded-md">
							<!-- <button type="button" class="text-xl py-1 px-2 hover:bg-gray-300" @click="decrementQty(item)">-</button> -->
							<input type="number" class="p-1 px-2 font-mono w-16" v-model="item.qty">
							<!-- <button type="button" class="text-xl py-1 px-2 hover:bg-gray-300" @click="item.qty++">+</button> -->
						</div>
					</div>
				</div>

				<button type="button" :disabled="cart.items.length == 0" class="btn w-full mt-4" @click="step++" :class="cart.items.length ? 'btn-primary' : 'bg-gray-100' ">Request a Quote</button>
			</div>
			<button class="flex gap-2 cursor-pointer font-light" v-show="step == 1" @click="step = 0">
				<!-- back icon -->
				 <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-4">
					<path stroke-linecap="round" stroke-linejoin="round" d="M9 15 3 9m0 0 6-6M3 9h12a6 6 0 0 1 0 12h-3" />
				</svg>
				<p class="text-sm">Back</p>
			</button>
			<div class="flex gap-2" v-show="step == 1">
				<div v-for="item in cart.items" class="px-2 py-2 relative border border-gray-200 mt-2 rounded-lg">
					<img :src="productImage(item)" class="size-14">
					<div class="bg-green-600 text-white rounded-full text-sm absolute bottom-1 right-1 px-1.5 border border-gray-800">
						{{  item.qty }}
					</div>
				</div>
			</div>
  			<!-- Quote -->
			<checkout-form id="form" class="" :categories="categories" v-show="step == 1"></checkout-form>
		</div>
	</div>
</template>

<script>
import { defineComponent } from 'vue';
import { cart } from '../cart';

export default defineComponent({
	props: {
		categories: {
			type: Object
		},
	},
	data(){
		return {
			step: 0,
			showCart: false,
			cart: { }
		}
	},
	methods:{
		decrementQty(item){
			cart.decrementQty(item)
		},
		removeItem(item){
			cart.removeItem(item);
		},
		productImage(item) {
			if(Array.isArray(item.product.variants[item.color].image))
			{
				return item.product.variants[item.color].image[0]	
			}
			return item.product.variants[item.color].image
		}
	},
	mounted(){
		cart.on("update", (newCart)=>{
			this.cart = newCart;
			this.cart.items.push({})
			this.cart.items.pop()
			if (this.cart.items.length){
				this.showCart = true;
			} else{
				this.showCart = false;
			}
		})
		this.cart = cart;
	}
});
</script>